<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
<!--            <el-form-item label="视频">-->
<!--                <GridSelectVideo style="width: 186px;" labelName="videoDesc" labelValue="id"-->
<!--                                 :value="queryForm.videoId" :limit='1' size='small' placeholder='请选择视频'-->
<!--                                 @getValue="getSeachValueVideo" :columns="VIDEO_code" :searchs="VIDEO_search"-->
<!--                                 dataListUrl="/video/video/findList" entityBeanName="videoVideo"-->
<!--                                 queryEntityUrl="/video/video/get">-->
<!--                </GridSelectVideo>-->
<!--            </el-form-item>-->
            <!-- <el-form-item label="用户">
              <GridSelectU style="width: 186px;" labelName="userName" labelValue="id"
                      :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="[
                        {
                          prop: 'userName',
                          label: '账号'
                        },
                        {
                          prop: 'userMobile',
                          label: '手机号'
                        }
                      ]" :searchs="[
                        {
                          prop: 'userName',
                          label: '账号'
                        },
                        {
                          prop: 'userMobile',
                          label: '手机号'
                        }
                      ]" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                    </GridSelectU>
            </el-form-item> -->
            <el-form-item label="产品">
                <GridSelectLi
                    :disabled="videoProductState == 'check'"
                    style="width: 186px"
                    title="选择商品"
                    labelName="productName"
                    labelValue="id"
                    :value="queryForm.productId"
                    :limit="1"
                    size="small"
                    placeholder="请选择商品"
                    @getValue="getSeachValuebrandId"
                    :columns="PRODUCT_code"
                    :searchs="PRODUCT_search"
                    dataListUrl="/shop/product/findList"
                    entityBeanName="shopProduct"
                    queryEntityUrl="/shop/product/get"
                >
                </GridSelectLi>
            </el-form-item>
            <!-- <el-form-item label="排序">
              <el-input v-model="queryForm.sort"></el-input>
            </el-form-item> -->
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getVideoProductList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addVideoProduct">新建</el-button>
                    <el-button type="warning" plain size="small" icon="el-icon-edit"
                               :disabled="multipleSelection.length != 1"
                               @click="editVideoProduct(null)">修改
                    </el-button>
                    <el-button type="danger" plain size="small" icon="el-icon-delete"
                               :disabled="multipleSelection.length <= 0"
                               @click="deleteVideoProduct(null)">删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <!-- <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
                      :show-file-list="true">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload> -->
                    <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
                    <!-- <span title="下载模板" class="icon-box" @click="importTemplate">
                      <Icon color="#606266">
                        <ArrowDown />
                      </Icon>
                    </span>
                    <span class="icon-box" title="导入数据" @click="isImport">
                      <Icon color="#606266">
                        <ArrowExportUp24Regular />
                      </Icon>
                    </span>
                    <span title="导出数据" class="icon-box" @click="exportVideoProductList">
                      <Icon color="#606266">
                        <ArrowDownload24Regular />
                      </Icon>
                    </span> -->
                    <span class="icon-box" @click="refreshVideoProductList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table :data="videoProductList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
                      :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }"
                      :cell-style="{ padding: '9px' }"
                      @selection-change="handleSelectionChange" size="samll">
                <el-table-column align="center" type="selection" width="60"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="video.videoPic" label="视频"
                                 width="180">
                    <template slot-scope="scope">
                        <div v-if='scope.row.video.videoPic'>
                            <el-image @click='updateSrcList(scope.row.video.videoPic)' style="width: 30px; height: 30px"
                                      :src="scope.row.video.videoPic" :preview-src-list="srcList"></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="product.productName" label="商品"
                                 width="205">
                    <template slot-scope="scope">
                        <div v-if='scope.row.product'>
                            <div style='text-align: left'>名称：{{ scope.row.product.productName }}</div>
                            <div style='text-align: left'>货号：{{ scope.row.product.productNumber }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="product.productPic" label="商品图片"
                                 width="180">
                    <template slot-scope="scope">
                        <div v-if='scope.row.product'>
                            <el-image @click='updateSrcList(scope.row.product.productPic)'
                                      style="width: 60px; height: 60px"
                                      :src="scope.row.product.productPic" :preview-src-list="srcList"></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="productId" label="价格" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.product">
                            <div style='text-align: left'>商品价格：{{ scope.row.product.shopPrice }}</div>
                            <div style='text-align: left'>市场价格：{{ scope.row.product.marketPrice }}</div>
                            <div style='text-align: left'>供货价格：{{ scope.row.product.supplyPrice }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="category.categoryName"
                                 label="所属分类" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="sort" label="排序" width="180">
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="300">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkVideoProduct(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editVideoProduct(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteVideoProduct(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination @size-change="sizeChange" @current-change="currentChange"
                               :current-page.sync="currentPage"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="totalNum" background :pager-count="7">
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog :title="videoProductStates[videoProductState]" :visible.sync="showDialog" width="60%"
                       :modal='false' @close="closeDialog">
                <div>
                    <el-form :model="videoProduct" ref="videoProductForm" :rules="rules" label-width="80px"
                             :inline="true"
                             size="small">
<!--                        <el-form-item label="视频" prop="videoId">-->
<!--                            <GridSelectVideo title="选择视频" style="width: 210px;" labelName="videoDesc"-->
<!--                                             :disabled="videoProductState == 'check'" labelValue="id"-->
<!--                                             :value="videoProduct.videoId" :limit='1' size='small'-->
<!--                                             placeholder='请选择视频' @getValue="getValueVideo" :columns="VIDEO_code"-->
<!--                                             :searchs="VIDEO_search" dataListUrl="/video/video/findList"-->
<!--                                             entityBeanName="videoVideo" queryEntityUrl="/video/video/get">-->
<!--                            </GridSelectVideo>-->
<!--                        </el-form-item>-->
                        <el-form-item label="商品" prop="productId">
                            <GridSelectLi
                                :disabled="videoProductState == 'check'"
                                style="width: 210px"
                                title="选择商品"
                                labelName="productName"
                                labelValue="id"
                                :value="videoProduct.productId"
                                :limit="1"
                                size="small"
                                placeholder="请选择商品"
                                @getValue="getValuebrandId"
                                :columns="PRODUCT_code"
                                :searchs="PRODUCT_search"
                                dataListUrl="/shop/product/findList"
                                entityBeanName="shopProduct"
                                queryEntityUrl="/shop/product/get"
                            >
                            </GridSelectLi>
                        </el-form-item>
                        <el-form-item label="排序" prop="sort">
                            <el-input style="width: 210px;" size="small" v-model="videoProduct.sort"
                                      :disabled="videoProductState == 'check'"></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="videoProductState != 'check'">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import GridSelectVideo from '@/components/video';
import { PRODUCT, PRODUCT_SEARCH, VIDEO, VIDEO_SEARCH } from '@/utils/constant.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU,
        GridSelectLi,
        GridSelectVideo
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetVideoProductList();
                this.getVideoProductList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetVideoProductList();
                this.getVideoProductList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                videoId: '', //视频
                userId: '', //用户
                productId: '', //产品id
                sort: '' //排序
            },
            PRODUCT_code: PRODUCT,
            PRODUCT_search: PRODUCT_SEARCH,
            VIDEO_code: VIDEO,
            VIDEO_search: VIDEO_SEARCH,
            srcList: [''],//大图预览
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            videoProductState: 'add',
            videoProductStates: {
                add: '新建商品',
                check: '查看商品',
                edit: '修改商品'
            },

            multipleSelection: [],
            videoProductList: [],
            videoProduct: {
                videoId: '', //视频
                userId: '', //用户
                productId: '', //产品id
                sort: 10 //排序
            },
            btnLoading: false,

            rules: {
                videoId: [{ required: true, message: '视频不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                productId: [{ required: true, message: '产品id不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
            }
        };
    },
    // created() {
    //     this.getVideoProductList();
    //     console.log(PRODUCT);
    // },
    methods: {
        // 大图预览
        updateSrcList(src) {
            console.log(src);
            this.srcList[0] = src;
        },
        // 搜索视频
        getSeachValueVideo(value) {
            this.queryForm.videoId = value;
        },
        // 搜索商品
        getSeachValuebrandId(value) {
            this.queryForm.productId = value;
        },
        // 搜索用户
        getSeachValueUser(value) {
            this.queryForm.userId = value;
        },
        // 选择商品
        getValuebrandId(value) {
            this.videoProduct.productId = value;
        },
        // 选择视频
        getValueVideo(value) {
            this.videoProduct.videoId = value;
            console.log(this.videoProduct.videoId);
        },
        // 选择用户
        getValueUser(value) {
            this.videoProduct.userId = value;
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetVideoProductList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.videoProductList = [];
        },
        resetDialog() {
            this.videoProductState = 'add';
            this.showDialog = false;
            this.queryForm = {
                videoId: this.queryForm.videoId, //视频
                userId: '', //用户
                productId: '', //产品id
                sort: '' //排序
            };
            this.getVideoProductList();
        },
        closeDialog() {
            this.showDialog = false;
            this.videoProduct = {
                videoId: '', //视频
                userId: '', //用户
                productId: '', //产品id
                sort: 10 //排序
            };
        },
        submitForm() {
            if (this.videoProductState == 'add') {
                this.$refs.videoProductForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/video/product/add`, { ...this.videoProduct }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetVideoProductList();
                                this.resetDialog();
                                this.getVideoProductList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.videoProductState == 'edit') {
                this.$refs.videoProductForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.videoProduct.video;
                        delete this.videoProduct.product;

                        post(`/video/product/edit`, { ...this.videoProduct }).then((res) => {
                            if (res.success || res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetVideoProductList();
                                this.resetDialog();
                                this.getVideoProductList();
                            }
                        });
                    }
                });
            }
        },
        addVideoProduct() {
            this.showDialog = true;
            this.videoProductState = 'add';
            this.videoProduct.videoId = this.queryForm.videoId
        },
        checkVideoProduct(videoProductId) {
            console.log(videoProductId);
            this.currentVideoProductId = videoProductId;

            this.getVideoProductById();
            this.showDialog = true;
            this.videoProductState = 'check';
        },
        editVideoProduct(videoProductId) {
            console.log('videoProduct', videoProductId);
            if (videoProductId) {
                this.currentVideoProductId = videoProductId;
                this.getVideoProductById();
            } else {
                this.videoProduct = { ...this.videoProduct, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.videoProductState = 'edit';
        },
        deleteVideoProduct(videoProductId) {
            let ids = '';
            if (videoProductId) {
                ids = videoProductId;
            } else {
                ids = this.multipleSelection.map((videoProduct) => videoProduct.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/video/product/delete`, { ids }).then((res) => {
                        if (res.success || res.code == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetVideoProductList();
                            this.getVideoProductList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshVideoProductList() {
            this.resetVideoProductList();
            this.getVideoProductList();
        },
        getVideoProductList(query = {}) {
            this.loading = true;
            get(`/video/product/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success || res.code == 200) {
                    this.videoProductList = res.page.list;
                    this.totalNum = res.page.total;
                    console.log(this.videoProductList);
                }
            });
        },
        getVideoProductById() {
            get(`/video/product/get`, { id: this.currentVideoProductId }).then((res) => {
                if (res.success || res.code == 200) {
                    this.videoProduct = { ...this.videoProduct, ...res.videoProduct };
                    console.log(this.videoProduct);
                }
            });
        },
        /**
         * 导出信息
         */
        exportVideoProductList() {
            //this.btnLoading = true;
            exprotExcel(`/video/product/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/video/product/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/video/product/importData`, formData);
            this.refreshVideoProductList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getVideoProductList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getVideoProductList();
        },
        show(id){
            this.queryForm.videoId = id;
            this.getVideoProductList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>